import React, { useState } from "react";
import Navbar from "../components/navbar";
import CommitteeTable from "../components/committee-table";
import CTAButtons from "../components/sticky-button";
import BrochureForm from "../components/brochure-form";
import Footer from "../components/Footer";
import PageHeader from "./PageHeader";
import "../components/governing.css";

const committeeDataByYear = {
"A.Y. 2025-26": [
    { section: "Chairperson", no: "1", councilPosition: "Chairperson", name: "Dr. Pravin Gundalwar", designation: "Director, TIMSCDR" },
    { section: "Head of Department", no: "2", councilPosition: "Head of Department", name: "Mr. Shirshendu Maitra", designation: "Asst. Prof & HoD Academics, TIMSCDR" },
    { section: "Teaching Staff", no: "3", councilPosition: "Teaching Staff", name: "Prof. Sonu Gupta", designation: "Asst. Prof & Dy. Director, TIMSCDR" },
    { section: "Teaching Staff", no: "4", councilPosition: "Member", name: "Dr. Ashwini Renavikar", designation: "Professor & HOD MCA Integrated" },
    { section: "Teaching Staff", no: "5", councilPosition: "Member", name: "Dr. Padma Mishra", designation: "Associate Professor, TIMSCDR" },
    { section: "Teaching Staff", no: "6", councilPosition: "Member", name: "Ms. Kinjal Doshi", designation: "Assistant Professor, TIMSCDR" },
    { section: "Expert / Academicians", no: "7", councilPosition: "Expert / Academicians", name: "Ms. Ritu Rungta", designation: "Associate Vice President, Xoriant" },
    { section: "Expert / Academicians", no: "8", councilPosition: "Member", name: "Dr. Mukesh Gupta", designation: "Founder, Lenest" },
    { section: "Expert / Academicians", no: "9", councilPosition: "Member", name: "Dr. Sheetal Rathi", designation: "Professor & Dean, Dept of CS, TCET" },
    { section: "Expert / Academicians", no: "10", councilPosition: "Member", name: "Mr. Sanjay Kimbahune", designation: "Senior Researcher, Tata Consultancy Services Limited" },
    { section: "University Nominee", no: "11", councilPosition: "University Nominee", name: "Dr. Rasika Mallya", designation: "Associate Director, NMITD" },
    { section: "University Nominee", no: "12", councilPosition: "Member", name: "Dr. Suhasini Vijaykumar Kottur", designation: "Professor & Principal, Computer Applications, BVIMIT" },
    { section: "University Nominee", no: "13", councilPosition: "Member", name: "Dr. Shivkumar Goel", designation: "HoD MCA, VESIT" },
    { section: "Other", no: "14", councilPosition: "Controller of Examination", name: "Ms. Rashmi Vipat", designation: "Assistant Professor, TIMSCDR" },
    { section: "Other", no: "15", councilPosition: "Member Secretary", name: "Ms. Rupali Jadhav", designation: "Assistant Professor, IQAC Coordinator, TIMSCDR" }
  ],
  "A.Y. 2024-25": [
    { section: "Management", no: "1", councilPosition: "Chairman", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR" },
    { section: "Head of Department", no: "2", councilPosition: "Head of Department", name: "Mr. Shirshendu Maitra", designation: "Asst. Prof & HoD Academics, TIMSCDR" },
    { section: "Teaching Staff", no: "3", councilPosition: "Teaching Staff", name: "Ms. Sonu Gupta", designation: "Asst. Prof & Dy. Director, TIMSCDR" },
    { section: "Teaching Staff", no: "4", councilPosition: "Member", name: "Dr. Ashwini Renavikar", designation: "Professor, TIMSCDR" },
    { section: "Teaching Staff", no: "5", councilPosition: "Member", name: "Dr. Padma Mishra", designation: "Associate Professor, TIMSCDR" },
    { section: "Teaching Staff", no: "6", councilPosition: "Member", name: "Ms. Kinjal Doshi", designation: "Assistant Professor, TIMSCDR" },
    { section: "Expert / Academicians", no: "7", councilPosition: "Expert / Academicians", name: "Ms. Ritu Rungta", designation: "Associate Vice President, Xorient" },
    { section: "Expert / Academicians", no: "8", councilPosition: "Member", name: "Dr. Mukesh Gupta", designation: "Founder, Lenest" },
    { section: "Expert / Academicians", no: "9", councilPosition: "Member", name: "Dr. Sheetal Rathi", designation: "Professor & Dean, Dept of CS, TCET" },
    { section: "Expert / Academicians", no: "10", councilPosition: "Member", name: "Mr. Sanjay Kimbahune", designation: "Senior Researcher, Tata Consultancy Services Limited" },
    { section: "University Nominee", no: "11", councilPosition: "University Nominee", name: "To be received", designation: "-" },
    { section: "University Nominee", no: "12", councilPosition: "Member", name: "To be received", designation: "-" },
    { section: "University Nominee", no: "13", councilPosition: "University Nominee", name: "To be received", designation: "-" },
    { section: "Other", no: "14", councilPosition: "Controller of Examination", name: "Ms. Rashmi Vipat", designation: "Assistant Professor, TIMSCDR" },
    { section: "Other", no: "15", councilPosition: "Member Secretary", name: "Ms. Rupali Jadhav", designation: "Assistant Professor, IQAC Coordinator, TIMSCDR" }
  ]
};

function AcademicCouncil() {
  const [showForm, setShowForm] = useState(false);
  const [selectedYear, setSelectedYear] = useState("A.Y. 2024-25");
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="governing-page-wrapper">
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
      <PageHeader
        title="Academic Council"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Academic Council" },
        ]}
      />

      <div className="governing-layout">
        <aside className="year-selector">
          <h3>
            <span className="year-selector-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
            ACADEMIC YEAR
          </h3>
          <ul>
            {Object.keys(committeeDataByYear).map((year) => (
              <li
                key={year}
                className={year === selectedYear ? "active" : ""}
                onClick={() => setSelectedYear(year)}
              >
                {year}
              </li>
            ))}
          </ul>
        </aside>

        <main className="table-area">
          <div className="table-header-control-bar">
            <h3 className="governing-title">Members of Academic Council - {selectedYear}</h3>
            <div className="table-actions-row">
              <div className="search-box-wrapper">
                <input
                  type="text"
                  placeholder="Search member..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              </div>
            </div>
          </div>

          <div className="tables-container">
            <CommitteeTable data={committeeDataByYear[selectedYear]} searchTerm={searchTerm} />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default AcademicCouncil;